module.exports = __webpack_public_path__ + "static/img/QR.f2ca21a.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/QR.png
// module id = SQRi
// module chunks = 1